import { app } from '../../../../../app';
import { Controller } from './administrators-developers.controller';

app.component('companyUserDirectoriesSaaspassUsersAdministratorsDevelopers', {
    bindings: {
        administrators: '<',
		labels: '<',
        numberOfUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./administrators-developers.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/administrators-developers/administrators-developers.component.js